import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from './dialog.js';
const ConfirmContext = createContext(null);
export function ConfirmProvider({ children }) {
    const [active, setActive] = useState(null);
    const request = useCallback((options) => {
        return new Promise((resolve) => {
            setActive({ options, resolve });
        });
    }, []);
    const handleClose = (ok) => {
        if (!active)
            return;
        active.resolve(ok);
        setActive(null);
    };
    const tone = active?.options.tone ?? 'default';
    const isDanger = tone === 'danger';
    return (_jsxs(ConfirmContext.Provider, { value: { request }, children: [children, _jsx(Dialog, { open: !!active, onClose: () => handleClose(false), size: "sm", "aria-label": active?.options.title, children: active && (_jsxs(_Fragment, { children: [_jsx(DialogHeader, { title: active.options.title, onClose: () => handleClose(false) }), _jsx(DialogBody, { children: _jsxs("div", { style: { display: 'flex', alignItems: 'flex-start', gap: 14 }, children: [isDanger && (_jsx("div", { style: {
                                            width: 36,
                                            height: 36,
                                            borderRadius: 8,
                                            background: 'var(--mm-terracotta-soft)',
                                            color: 'var(--st-bad)',
                                            display: 'grid',
                                            placeItems: 'center',
                                            flexShrink: 0,
                                        }, children: _jsx(AlertTriangle, { size: 18, strokeWidth: 2.2 }) })), _jsx("p", { style: {
                                            margin: 0,
                                            fontSize: 14,
                                            lineHeight: 1.55,
                                            color: 'var(--text-2)',
                                        }, children: active.options.description ?? 'Are you sure you want to continue?' })] }) }), _jsxs(DialogFooter, { children: [_jsx("button", { type: "button", className: "btn", onClick: () => handleClose(false), children: active.options.cancelLabel ?? 'Cancel' }), _jsx("button", { type: "button", className: isDanger ? 'btn btn-accent' : 'btn btn-primary', onClick: () => handleClose(true), autoFocus: true, children: active.options.confirmLabel ?? 'Confirm' })] })] })) })] }));
}
export function useConfirm() {
    const ctx = useContext(ConfirmContext);
    if (!ctx) {
        throw new Error('useConfirm must be used inside <ConfirmProvider>');
    }
    return ctx.request;
}
//# sourceMappingURL=confirm-dialog.js.map